// Özet kuyruğu "aralık dışı onay bekleyen" uyarısı (2026-10-08 manuel test): kuyruk yüklü grid'den
// türediği için müşterinin aralık dışı bir yıla (ör. 2026) yazdığı değer görünmüyordu. Yıllar
// `GET /kpi/sets/:id/pending-years` ile aralıktan bağımsız okunur; "Aralığı genişlet" aralık ∪ yıllar.
import { useEffect, useMemo, useState } from "react";
import { listKpiPendingYears } from "../../api/kpi";
import { KPI_COPY } from "../../lib/kpi-ui";

export function KpiQueueOutsideYears({
  setId,
  years,
  onExtendYears,
  refreshKey,
}: {
  setId: string;
  years: number[] | undefined;
  onExtendYears: ((years: number[]) => void) | undefined;
  /** grid yenilenince yeniden sorulur */
  refreshKey: unknown;
}): JSX.Element | null {
  const [pendingYears, setPendingYears] = useState<number[]>([]);
  useEffect(() => {
    let alive = true;
    listKpiPendingYears(setId)
      .then((ys) => {
        if (alive) setPendingYears(ys);
      })
      .catch(() => {
        /* uyarı alınamazsa yalnız grid kuyruğu kalır */
      });
    return () => {
      alive = false;
    };
  }, [setId, refreshKey]);
  const outside = useMemo(
    () => (years ? pendingYears.filter((y) => !years.includes(y)) : []),
    [pendingYears, years],
  );
  if (outside.length === 0) return null;
  return (
    <div
      role="status"
      data-testid="kpi-queue-outside-years"
      className="rounded-xl px-3 py-2 text-xs mb-3 flex items-center gap-3 flex-wrap"
      style={{
        border: "1px solid var(--color-warning-border)",
        background: "var(--color-warning-bg)",
        color: "var(--color-warning-text)",
      }}
    >
      <span style={{ flex: 1, minWidth: 0 }}>{KPI_COPY.queue.outsideYears(outside)}</span>
      {onExtendYears ? (
        <button
          type="button"
          onClick={() => onExtendYears(outside)}
          className="px-3 py-1 rounded-lg font-semibold"
          style={{
            border: "1px solid var(--color-warning-border)",
            background: "var(--color-surface)",
            color: "var(--color-warning-text)",
            minHeight: 28,
          }}
        >
          {KPI_COPY.queue.extendYears}
        </button>
      ) : null}
    </div>
  );
}
